import { PrerequisiteRuleTypes, type ExtensionConfig } from '@goto/shell-common'
import { getFeatureFlag } from '../helpers/shell-helpers'

const extensionConfig: ExtensionConfig = {
  id: '@goto/shell-extensions-widgets',
  esModule: true,
  get url() {
    const version = getFeatureFlag('shell-extensions-widgets-version', 'latest')
    return new URL(`experiences/shell-extensions/${version}/widgets/index.js`, location.origin)
  },
  prerequisites: {[PrerequisiteRuleTypes.SHELL_FEATURE_FLAGS]: "insights.enable",},
}

export default extensionConfig
